<template>
	<ValidationObserver ref="observer" v-slot="{ passes }">
		<form @submit.prevent="passes(() => {})" autocomplete="disabled" onkeydown="return event.key != 'Enter';">
			<div class="mdl-grid" v-if="isPasswordChanged">
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group success">
					<i class="material-icons">check_circle</i>
					{{ T("ticketing_password_reset_success") }}
				</div>
			</div>
			<div class="mdl-grid" v-else>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
					<label>{{ T("new_password") }}</label>
					<input type="password" v-model.trim="password" autocomplete="off" class="mdl-textfield__input" />
				</div>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
					<label>{{ T("password_repeat") }}</label>
					<input v-model.trim="password_repeat" type="password" autocomplete="off" class="mdl-textfield__input" />
				</div>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
					<passwordStrength :password="password" :password_repeat="password_repeat" @isValid="isValid => isPasswordValid = isValid" />
				</div>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
					<p class="error" v-if="hasError">
						{{ T("ticketing_password_reset_error") }}
					</p>
				</div>
			</div>
		</form>
	</ValidationObserver>
</template>

<script>
	import {
		ValidationObserver
	} from "vee-validate";
	import passwordStrength from "../ui/password-strength.vue";
	import defaultMixin from "../../mixins/default";

	export default {
		name: "d21-modal-reset-password",
		mixins: [defaultMixin],
		components: {
			ValidationObserver,
			passwordStrength
		},
		data() {
			return {
				username: '',
				isPasswordChanged: false,
				hasError: false,
				password: '',
				password_repeat: ''
			}
		}
	}
</script>